import { render } from "./MyLeaveEntitlementReport.vue?vue&type=template&id=278b9dfc&scoped=true"
import script from "./MyLeaveEntitlementReport.vue?vue&type=script&lang=js"
export * from "./MyLeaveEntitlementReport.vue?vue&type=script&lang=js"

import "./MyLeaveEntitlementReport.vue?vue&type=style&index=0&id=278b9dfc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278b9dfc"]])

export default __exports__